// Shared page size for the first page of owned numbers. The startup hook and
// the selector UI use the same limit so they reuse one cache entry.
export const INITIAL_OWN_NUMBERS_LIMIT = 50;
